var render, staticRenderFns
import script from "./doughnutReactive.vue?vue&type=script&lang=js&"
export * from "./doughnutReactive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "723310ed",
  null
  
)

export default component.exports